var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{staticClass:"el-descriptions-item__cell el-descriptions-item__label is-bordered-label",attrs:{"colspan":_vm.span}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }